import React from 'react'

const Map = () => {
    return (
        <>
            <div className="map-section">
                <div className="container-fluid p-0">
                    <div className="map" />
                </div>
            </div>

        </>
    )
}

export default Map
